import { createStore } from 'effector'
import { FarcanaStatsResponse } from '../types'
import { getAppStatusFx, getFarcanaStatsFx } from './effects'

export const $farcanaStatistics = createStore<FarcanaStatsResponse | null>(null).on(
  getFarcanaStatsFx.doneData,
  (_, data) => data
)

export const $isAppUpdating = createStore<boolean>(false).on(getAppStatusFx.doneData, (_, data) => !data)
